import { render, staticRenderFns } from "./checkRecord.vue?vue&type=template&id=774389fa&scoped=true&"
import script from "./checkRecord.vue?vue&type=script&lang=js&"
export * from "./checkRecord.vue?vue&type=script&lang=js&"
import style0 from "./checkRecord.vue?vue&type=style&index=0&id=774389fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774389fa",
  null
  
)

export default component.exports